import React, { useEffect, useState, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PRIVATE_ROUTE_USER_TYPE_CONFIG } from './routeConfig';
import { Layout } from 'antd';
import {
  CURRENT_USER_TYPE,
  getItem,
  logoutUser,
} from '../utils/cookieManager';
import { Flex, Spin } from '../components/common';

const { Content } = Layout;

const PrivateRoutes = () => {
  const [currentUserType, setCurrentUserType] = useState(null);
  const location = useLocation();
  useEffect(() => {
    const userType = getItem(CURRENT_USER_TYPE);
    if (!userType) {
      logoutUser();
      window.location.replace('/auth/login');
      return;
    }
    setCurrentUserType(userType);
  }, []);

  const currentPath = location.pathname;
  const allowedRoles = PRIVATE_ROUTE_USER_TYPE_CONFIG[currentPath];

  if (currentUserType === null) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (allowedRoles && !allowedRoles.includes(currentUserType)) {
    logoutUser();
    window.location.replace('/auth/login');
    return null;
  }

  return (
    <Layout className="h-screen">
      <Flex justify="space-between" className="w-full h-full">
        <Content className="h-full overflow-y-auto">
          <Suspense fallback={<Spin size="large" />}>
            <Outlet />
          </Suspense>
        </Content>
      </Flex>
    </Layout>
  );
};

export default PrivateRoutes;
